export const unmountInitialLoading = () => {
    setTimeout(() => {
        const loadingElement = document.querySelector('.initial-loading');

        loadingElement?.classList.add('initial-loading--hidden');
    }, 300);
};
